/**
 * Convert list of [lat, lng] to [lng, lat]
 * @param {Array} latLng list containing [lat, lng]
 */
export const latLngToLngLat = (latLng) => {
  if (!latLng || latLng.length === 0) {
    return [];
  }

  if (Array.isArray(latLng[0])) {
    return latLng.map((p) => [p[1], p[0]]);
  }
  return [latLng[1], latLng[0]];
};

/**
 * Get if a givev point is in the bounds of the map
 * @param {Object} point Object containing lat and lng coordinates
 * @param {Object} bounds map.getBounds() object
 */
export const inBounds = ({ lng, lat }, { _ne, _sw }) => {
  const lg = (lng - _ne.lng) * (lng - _sw.lng) < 0;
  const lt = (lat - _ne.lat) * (lat - _sw.lat) < 0;
  return lg && lt;
};

/**
 * Returns coordinates for polygon circle
 *
 * @param {Array} center Array containing [lat, lng]
 * @param {*} radius Radius size in kilometers
 * @param {*} points How many points to use to generate a circle
 *
 * @returns {Array} Array of [lat, lng] coordinates for a circle
 */
export const getCircleCoords = (center, radius, points = 32) => {
  const centerCoords = {
    lat: center[1],
    lng: center[0]
  };
  const distanceX =
    radius / (111.32 * Math.cos((centerCoords.lat * Math.PI) / 180));
  const distanceY = radius / 110.574;
  const coords = [];

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < points; i++) {
    const theta = (i / points) * (2 * Math.PI);
    const x = distanceX * Math.cos(theta);
    const y = distanceY * Math.sin(theta);

    coords.push([centerCoords.lng + x, centerCoords.lat + y]);
  }
  coords.push(coords[0]);

  return coords;
};

/**
 * Returns id if layer exists on the map and null when it does not, this prevents
 * mapbox-gl throwing an error when layer does not exist and not drawing anything on the
 * map
 * @param {Instance} map mapbox-gl instance
 * @param {String} id Layer id
 *
 * @returns {String|null} id when layer exists and null if layer does not exist
 */
export const getBeforeIdToUse = (map, id) => (map.getLayer(id) ? id : null);

export default {
  latLngToLngLat,
  inBounds,
  getCircleCoords,
  getBeforeIdToUse
};
